export function imageFitCanvas(img, fab, margin = 20) {
  const availableWidth = fab.width - margin * 2
  const availableHeight = fab.height - margin * 2

  // 计算保持宽高比的缩放比例
  const scale = Math.min(availableWidth / img.width, availableHeight / img.height)

  // 应用缩放
  img.scale(scale)

  // 计算居中位置
  const centerX = fab.width / 2
  const centerY = fab.height / 2

  img.set({
    left: centerX,
    top: centerY,
    originX: 'center',
    originY: 'center'
  })
}

export function fitToViewport(fab, padding = 30) {
  if (!fab || fab.getObjects().length === 0) return

  fab.setViewportTransform([1, 0, 0, 1, 0, 0]) // 重置变换

  // 1. 获取所有对象的联合边界
  const bbox = getContentBoundingBox(fab)

  // 2. 计算缩放比例
  const canvasWidth = fab.getWidth()
  const canvasHeight = fab.getHeight()

  // 计算内容尺寸（包括内边距）
  const contentWidth = bbox.width + padding * 2
  const contentHeight = bbox.height + padding * 2

  // 计算缩放比例（取最小比例确保内容完全可见）
  const scaleX = canvasWidth / contentWidth
  const scaleY = canvasHeight / contentHeight
  const scale = Math.min(scaleX, scaleY)

  // 3. 计算平移位置（中心对齐）
  const contentCenterX = (bbox.left + bbox.right) / 2
  const contentCenterY = (bbox.top + bbox.bottom) / 2

  const viewportCenterX = canvasWidth / 2
  const viewportCenterY = canvasHeight / 2

  // 4. 计算平移偏移量（考虑缩放）
  const offsetX = viewportCenterX - contentCenterX * scale
  const offsetY = viewportCenterY - contentCenterY * scale

  // 5. 应用变换
  fab.setViewportTransform([
    scale,
    0, // X轴缩放
    0,
    scale, // Y轴缩放
    offsetX, // X轴平移
    offsetY // Y轴平移
  ])

  // 6. 确保渲染更新
  fab.requestRenderAll()
}

// 获取所有对象的联合边界
export function getContentBoundingBox(fab) {
  const objects = fab.getObjects()
  if (objects.length === 0) {
    return { left: 0, top: 0, width: 0, height: 0, right: 0, bottom: 0 }
  }

  let minX = Infinity,
    minY = Infinity,
    maxX = -Infinity,
    maxY = -Infinity

  objects.forEach((obj) => {
    // 使用 getBoundingRect() 考虑对象的变换状态
    const rect = obj.getBoundingRect()

    minX = Math.min(minX, rect.left)
    minY = Math.min(minY, rect.top)
    maxX = Math.max(maxX, rect.left + rect.width)
    maxY = Math.max(maxY, rect.top + rect.height)
  })

  if (fab.backgroundImage) {
    const image = fab.backgroundImage

    minX = Math.min(minX, image.left)
    minY = Math.min(minY, image.top)
    maxX = Math.max(maxX, image.left + image.width * image.scaleX)
    maxY = Math.max(maxY, image.top + image.height * image.scaleY)
  }

  return {
    left: minX,
    top: minY,
    width: maxX - minX,
    height: maxY - minY,
    right: maxX,
    bottom: maxY
  }
}

export default {
  imageFitCanvas,
  fitToViewport,
  getContentBoundingBox
}
